import { Button, Modal } from 'antd';

import styles from './PublishModalError.module.scss';

export enum PUBLISH_ERROR_TYPE {
  ROOM = 'Room',
  ACTIVITY = 'Activity',
  HOTEL = 'Hotel',
  PACKAGE = 'Package',
}

type PublishModalErrorProps = {
  type: PUBLISH_ERROR_TYPE;
  missingFields: string[];
  isOpen: boolean;
  handleOk: () => void;
};

export const PublishModalError = ({
  type,
  missingFields,
  isOpen,
  handleOk,
}: PublishModalErrorProps) => {
  return (
    <Modal
      title="Unable to publish"
      className={styles.publishModalError}
      open={isOpen}
      centered={true}
      destroyOnClose
      closable={false}
      footer={[
        <Button key="close" type="primary" onClick={handleOk}>
          Ok
        </Button>,
      ]}
    >
      <div className={styles.publishModalErrorContent}>
        <p>
          This {type} cannot be published because the following mandatory fields
          are missing:
        </p>
        <ul className={styles.publishModalErrorList}>
          {missingFields.map((field) => (
            <li key={field}>{field}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};
